import React from 'react';

import styled from 'styled-components';

import { DatasetModel } from '../../../models/dataset.model';
import { FormulaDetailModel } from '../../../models/formula.model';

import SettingsContainer from '../../display/layout/SettingsContainer';
import DeeplinkView from './deeplink/View';

interface DeeplinkProps {
    formula: FormulaDetailModel;
    dataset: DatasetModel | null;
}

const DeeplinkSettings: React.FC<React.PropsWithChildren<DeeplinkProps>> = ({
    formula,
    dataset,
}) => {
    const staticField = formula.deeplink;
    const datasetFieldId = formula.deeplink_dataset_field_id
        ? Number(formula.deeplink_dataset_field_id.split('.')[0])
        : null;

    const datasetDeeplink = React.useMemo(() => {
        if (dataset && datasetFieldId !== null) {
            const field = dataset.fields[datasetFieldId];
            return {
                datasetName: dataset.name,
                fieldName: field.name || 'Error',
                fieldSample: field.sample || 'Error',
            };
        }
        return null;
    }, [dataset, datasetFieldId]);

    return (
        <SettingsContainer isDisabled>
            <FlexContainer>
                <DeeplinkView
                    staticDeeplink={staticField}
                    datasetDeeplink={datasetDeeplink}
                />
            </FlexContainer>
        </SettingsContainer>
    );
};

export default DeeplinkSettings;

const FlexContainer = styled.div({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
});
